import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from "@angular/core";
import * as Sentry from "@sentry/angular-ivy";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbDropdownModule, NgbModalModule, NgbModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { UsuarioPassChangeComponent } from './components/usuario/usuario-pass-change/usuario-pass-change.component';
import { UsuarioProfileComponent } from './components/usuario/usuario-profile/usuario-profile.component';
import { LoginComponent } from './utils/login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalDeleteModule } from './utils/modal-delete/modal-delete.module';
import { MarkdownModule } from 'ngx-markdown';
import { TosComponent } from './utils/tos/tos.component';
import { RecuperarContrasenaComponent } from './utils/recuperar-contrasena/recuperar-contrasena.component';
import { NuevaContrasenaComponent } from './utils/nueva-contrasena/nueva-contrasena.component';
import { SoporteComponent } from './utils/soporte/soporte.component';
import { VersionUpdateComponent } from './utils/version-update/version-update.component';
import { InfoAlertSiiModule } from './utils/info-alert-sii/info-alert-sii.module';
import { SharedModule } from './shared/shared.module';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { TestPlanSelectorComponent } from './utils/test-plan-selector/test-plan-selector.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ErrorUiModule } from './utils/error-ui/error-ui.module';
import { PendingChangesGuard } from './utils/confirmation/pending-changes.guard';
import { BusquedaComponent } from './utils/busqueda/busqueda.component';
import { NgxScannerQrcodeModule } from 'ngx-scanner-qrcode';
import { EncuestaNpsCreateComponent } from './components/encuesta-nps/encuesta-nps-create/encuesta-nps-create.component';
import { SubscriptionTosComponent } from './utils/subscription-tos/subscription-tos.component';
import { AyudaComponent } from './utils/ayuda/ayuda.component';
import { ModalModule } from './utils/modal/modal.module';
import { PaginaVaciaComponent } from './utils/pagina-vacia/pagina-vacia.component';
import { DatePipe } from '@angular/common';
import { AvisoSistemaComponent } from './utils/aviso-sistema/aviso-sistema.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { AgendarIframeComponent } from './utils/agendar-iframe/agendar-iframe.component';
import { AgendarIframeModule } from './utils/agendar-iframe/agendar-iframe.module';
import { UpSellingMessagesComponent } from './utils/upselling-messages/upselling-messages.component';

const maskConfig: Partial<IConfig> = {};

@NgModule({
  declarations: [
    AppComponent,
    UsuarioPassChangeComponent,
    UsuarioProfileComponent,
    RecuperarContrasenaComponent,
    NuevaContrasenaComponent,
    LoginComponent,
    TosComponent,
    SubscriptionTosComponent,
    SoporteComponent,
    VersionUpdateComponent,
    AvisoSistemaComponent,
    TestPlanSelectorComponent,
    BusquedaComponent,
    EncuestaNpsCreateComponent,
    AyudaComponent,
    PaginaVaciaComponent,
    UpSellingMessagesComponent,
  ],
  imports: [
    PickerModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MarkdownModule.forRoot(),
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    NgxKuvUtilsModule,
    NgbPopoverModule,
    NgbDropdownModule,
    HttpClientModule,
    NgbModalModule,
    NgxKuvToolsModule,
    NgSelectModule,
    NgxMaskModule.forRoot(maskConfig),
    NgSelectModule,
    ModalDeleteModule,
    InfoAlertSiiModule,
    SharedModule,
    FullCalendarModule,
    ErrorUiModule,
    AgendarIframeModule,
    NgxScannerQrcodeModule,
    ModalModule,
    ScrollingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    DatePipe,
    PendingChangesGuard,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
